'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DialogContentStyled = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var propTypes = {
  bordered: _propTypes2.default.bool,
  scrollable: _propTypes2.default.bool,
  displayFlex: _propTypes2.default.bool,
  followsHeading: _propTypes2.default.bool,
  paddingSize: _propTypes2.default.oneOf(['none', 'default']),

  /**
   * Define theme
   * See https://github.com/styled-components/styled-components/blob/master/docs/theming.md
   * for more information
   */
  theme: _propTypes2.default.object
};
var defaultProps = {
  bordered: false,
  scrollable: false,
  displayFlex: false,
  followsHeading: false,
  paddingSize: 'default'
};
/** Prop Receivers */

var baseProps = function baseProps(_ref) {
  var themeFromProvider = _ref.theme,
      paddingSize = _ref.paddingSize,
      followsHeading = _ref.followsHeading,
      bordered = _ref.bordered,
      displayFlex = _ref.displayFlex;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var _theme$reactackle$com = theme.reactackle.components.dialog.content,
      paddingX = _theme$reactackle$com.paddingX,
      paddingY = _theme$reactackle$com.paddingY,
      fontSize = _theme$reactackle$com.fontSize,
      lineHeight = _theme$reactackle$com.lineHeight,
      color = _theme$reactackle$com.color,
      fontWeight = _theme$reactackle$com.fontWeight,
      borderWidth = _theme$reactackle$com.borderWidth,
      borderColor = _theme$reactackle$com.borderColor;
  var py = (0, _reactackleCore.getValueString)(paddingY),
      px = (0, _reactackleCore.getValueString)(paddingX);
  var padding = paddingSize !== 'none' ? 'padding: ' + py + ' ' + px + ';' : '';
  return (0, _styledComponents.css)(['font-size:', ';line-height:', ';color:', ';font-weight:', ';', ' ', ' & + &{padding-top:0;margin-top:-calc(', ' / 2);}', ' ', ''], (0, _reactackleCore.getValueString)(fontSize), lineHeight, color, fontWeight, padding, followsHeading && 'padding-top: 0;', py, bordered ? 'border-top: ' + (0, _reactackleCore.getValueString)(borderWidth) + ' solid ' + borderColor + ';' : '', displayFlex && 'display: flex;');
};

var scrollable = function scrollable(_ref2) {
  var scrollable = _ref2.scrollable;
  return scrollable ? 'overflow-y: auto;' : '';
};
/** Styles */


var DialogContentStyled = exports.DialogContentStyled = _styledComponents2.default.div.withConfig({
  displayName: 'DialogContentStyled'
})(['flex-grow:1;position:relative;', ' ', ';'], baseProps, scrollable);

DialogContentStyled.propTypes = propTypes;
DialogContentStyled.defaultProps = defaultProps;
DialogContentStyled.displayName = 'DialogContentStyled';